import { toDictionary } from '@/utils/array'
import { packCriteria } from '@/utils/filters'
import { request } from '@/utils/request'
import { createScreener } from '@/utils/screener.js'

function unpackVersions(versions) {
    const companies = toDictionary(versions.companies, c => c.id)
    const executives = toDictionary(versions.executives, e => e.id)

    versions.versions.forEach(v => {
        v.company = companies[v.companyId]
        v.executive = executives[v.executiveId]
    })
    return versions.versions
}

function unpackHints(hints) {
    const companies = toDictionary(hints.companies, c => c.id)

    hints.hints.forEach(v => {
        v.company = companies[v.companyId]
    })

    return hints.hints
}

function unpackVersion(version) {
    if (!version) {
        return null
    }

    if (version.company) {
        version.version.company = version.company
    }

    if (version.executive) {
        version.version.executive = version.executive
    }

    return version.version
}

export function createVersion(companyId, options) {
    return request.post(`/api/manage/skillset-match/versions/companies/${companyId}`, options)
}

export async function searchVersions(criteria, pagination, sort, facets, signal = null) {
    const { ok, status, content } = await request.post(
        '/api/manage/skillset-match/versions/search',
        {
            criteria: packCriteria(criteria),
            ...pagination,
            ...sort,
            facets,
        },
        {
            signal,
        }
    )

    if (!ok) {
        throw { ok, status, content }
    }

    content.versions = unpackVersions(content)

    delete content.companies
    delete content.executives

    return content
}

export async function listVersionsByCompanyId(companyId) {
    return unpackVersions(await request.get(`/api/manage/skillset-match/versions/companies/${companyId}`))
}

export function updateVersion(id, body) {
    return request.put(`/api/manage/skillset-match/versions/${id}`, body)
}

export async function listHints() {
    return unpackHints(await request.get('/api/manage/skillset-match/hints'))
}

export function getHints(companyId) {
    return request.get(`/api/manage/skillset-match/hints/companies/${companyId}`)
}

export function updateHints(companyId, hints) {
    return request.put(`/api/manage/skillset-match/hints/companies/${companyId}`, hints)
}

export async function getSkillsetMatchVersion(id) {
    return unpackVersion(await request.get(`/api/skillset-match/${id}`))
}

export function createVersionsScreener(options = {}) {
    return createScreener(searchVersions, 'versions', options)
}

export async function getLatestForCompanyId(companyId) {
    return unpackVersion(await request.get(`/api/skillset-match/companies/${companyId}/latest`))
}
